<template>
  <v-card v-if="paymentProvider">
    <slot name="title">
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">{{ title }}</v-toolbar-title>
        <div class="flex-grow-1"></div>

        <v-spacer></v-spacer>
        <v-btn color="primary" @click="isUpdating = true">
          <v-icon>mdi-pencil</v-icon>
          Edit
        </v-btn>
      </v-toolbar>
    </slot>

    <v-card-text>
      <v-row>
        <v-col cols="4">
          <key-value title="Id">
            <span class="small" v-text="paymentProvider.id"></span>
          </key-value>
          <key-value title="Payment Method Name" :value="paymentProvider.name" />
        </v-col>
        <v-col cols="4">
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Payment Types</h4>
            <h2 class="body-1 font-weight-medium">
              <span v-for="(type, index) in paymentProvider.payment_types" :key="index">
                - {{ type.name }} <br />
              </span>
            </h2>
          </div>
        </v-col>
        <v-col cols="4"> </v-col>
      </v-row>
    </v-card-text>
    <update-payment-provider-form
      method="put"
      :paymentProvider="paymentProvider"
      :is-active.sync="isUpdating"
      @changed="paymentProviderUpdated"
    ></update-payment-provider-form>
  </v-card>
</template>

<script>
import UpdatePaymentProviderForm from "./form";

export default {
  props: {
    dataPaymentProvider: Object,
    title: { default: "Payment Provider Details" },
    hideActions: { type: Boolean, default: false },
  },
  components: { UpdatePaymentProviderForm },
  data() {
    return {
      isUpdating: false,
      paymentProvider: this.dataPaymentProvider,
    };
  },
  computed: {},
  methods: {
    paymentProviderUpdated({ paymentProvider }) {
      this.paymentProvider = paymentProvider;
      this.$emit("updated", paymentProvider);
      this.isUpdating = false;
    },
  },
};
</script>
